import { render, staticRenderFns } from "./CultureEdit.vue?vue&type=template&id=736e31d1&scoped=true&"
import script from "./CultureEdit.vue?vue&type=script&lang=js&"
export * from "./CultureEdit.vue?vue&type=script&lang=js&"
import style0 from "./CultureEdit.vue?vue&type=style&index=0&id=736e31d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736e31d1",
  null
  
)

export default component.exports